const toolByMonthPageIds = [
    'schoolId',
    'schoolYear',
    'toolGroup'
];

toolByMonthPageIds.forEach(id => {
    $('#' + id).selectize();
});
